// import React from "react";

// function ExportComponent({ handleOnExport }) {
//   return (
//     <div className="container-fluid">
//       <div className="m-1" style={{ textAlign: "right" }}>
//         <button className="btn btn-success" onClick={handleOnExport}>
//           {" "}
//           <i className="fa fa-download"></i>
//           Export Data{" "}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ExportComponent;

'use client';

function FloatingExportButton({ handleOnExport }) {
  return (
    <>
      <style jsx>{`
        .floating-export-btn {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 9999;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          border: none;
          border-radius: 50%;
          padding: 12px;
          font-size: 16px;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
          transition: all 0.3s ease;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .floating-export-btn:hover {
          background: linear-gradient(135deg, #059669 0%, #047857 100%);
          transform: translateY(-2px) scale(1.1);
          box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
          color: white;
        }

        .floating-export-btn:active {
          transform: translateY(0px) scale(1.05);
          box-shadow: 0 2px 10px rgba(16, 185, 129, 0.4);
        }

        .floating-export-btn:focus {
          outline: none;
          box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4),
            0 0 0 3px rgba(16, 185, 129, 0.3);
        }

        .export-icon {
          font-size: 18px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%,
          20%,
          50%,
          80%,
          100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-2px);
          }
          60% {
            transform: translateY(-1px);
          }
        }

        /* Remove the text span from the button */
        .export-text {
          display: none;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .floating-export-btn {
            bottom: 16px;
            right: 16px;
            width: 45px;
            height: 45px;
            padding: 10px;
          }

          .export-icon {
            font-size: 16px;
          }
        }

        @media (max-width: 480px) {
          .floating-export-btn {
            bottom: 12px;
            right: 12px;
            width: 42px;
            height: 42px;
            padding: 8px;
          }

          .export-icon {
            font-size: 15px;
          }
        }

        /* Ensure it doesn't interfere with other floating elements */
        .floating-export-btn {
          user-select: none;
        }

        /* Add a subtle pulse effect when idle */
        .floating-export-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 50%;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          opacity: 0;
          animation: pulse-ring 3s infinite;
          z-index: -1;
        }

        @keyframes pulse-ring {
          0% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.1;
          }
          100% {
            transform: scale(1.4);
            opacity: 0;
          }
        }

        /* Hover state removes the pulse */
        .floating-export-btn:hover::before {
          animation: none;
          opacity: 0;
        }
      `}</style>

      <button
        className='floating-export-btn'
        onClick={handleOnExport}
        title='Export Data'
        aria-label='Export Data'
      >
        <i className='fa fa-download export-icon'></i>
      </button>
    </>
  );
}

export default FloatingExportButton;
